module.exports = __webpack_public_path__ + "static/media/Fat.67c47ce7.png";